import { render, staticRenderFns } from "./NewMessageUploadEditor.vue?vue&type=template&id=6db74a2c&scoped=true"
import script from "./NewMessageUploadEditor.vue?vue&type=script&lang=js"
export * from "./NewMessageUploadEditor.vue?vue&type=script&lang=js"
import style0 from "./NewMessageUploadEditor.vue?vue&type=style&index=0&id=6db74a2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db74a2c",
  null
  
)

export default component.exports